import React from 'react';
import i18n from 'utils/i18n';

import css from './styles.module.scss';
import { Dropdown } from 'semantic-ui-react';
import {
  arrayOrNull,
  createFakeEvent,
  cropString,
  isNullish
} from '@/utils/functions';
import { postJSON } from '@/utils/http';
import { toast } from 'providers/ui';
import { formatsFromDGs } from '@/utils/functions';

/**
 * Atom LookupPicker
 * 
 * A picker to dynamically use existing modules.
 */
function LookupPicker (props) {
  const gt = i18n.useTranslations('modules.Globals');
  const [localOptions, setLocalOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [localFormat, setLocalFormat] = React.useState(null);
  const [localValue, setLocalValue] = React.useState(null);
  const [DSId, setDSId] = React.useState(null);

  const {
    className = "",
    children,
    name,
    label = '',
    src,
    onChange,
    required,
    multiple,
    // label,
    value,
    apis,
    ...other
  } = props;

  // just to be sure we are avoinding infinite loops
  other.type = 'text';

  function DISorter (a, b) {
    return (parseInt(a.format.isInLookup) - parseInt(b.format.isInLookup)) ||
      (a.format.name > b.format.name ? 1 : -1);
  }

  // async function fetchData () {
  //   setLoading(true);

  //   const { error } = (await postJSON('/api/data_structures/lookup', {
  //     id: src,
  //   }));

  //   if (error) {
  //     toast?.error(
  //       t(`Failed loading the information!`)
  //     );
  //     return console.error(error);
  //   }

  //   setLoading(false);
  // }

  // React.useEffect(_ => {
  //   fetchData();
  // }, []);

  React.useEffect(_ => {
    applyOptions(localValue);
  }, [ localValue ]);

  React.useEffect(_ => {
    if (value || !props.src) { // && !value.format && !localFormat) {
      // we need to retrieve the formats
      if (!localFormat) {
        if (!loading) {
          fetchFormatAndLookupValuesFor(value);
        }
      } else {
        // debugger;

        // setLocalValue()
      }
      // setLoading(true);
      // setLoading(false);
    }
  }, [value, localFormat]);

  async function fetchFormatAndLookupValuesFor (value) {
    setLoading(true);

    const { data:DSFormats, error } = (await postJSON(
      '/api/data_structures/dis',
      {
        dsId: props.src ||
          props.data?.DS?.id ||
          props.ds_id, // ||
        // value?.id ||
        // value?.ds_id ||
        // value?.dsId ||
        // value,
        dsName: props.srcName,
        // dsLevel: props.srcLevel,
        lookupOrGrid: 'Lookup',
        includeDSInfo: true
      }
    ));

    if (error) {
      console.error(error);
      toast.error(gt(`Could not retrieve the DataStructure for the "${name}" picker`));
      setLoading(false);
    }

    const lookupFieldsToFetch = {};

    Object.keys(DSFormats?.DGs || {}).forEach(groupName => {
      const groupId = DSFormats.DGs[groupName].groupId;
      lookupFieldsToFetch[groupId] = lookupFieldsToFetch[groupId] || [];
      lookupFieldsToFetch[groupId]
        .push(...(DSFormats.DGs[groupName].DIs.map(di => di.name)));
    });

    const localDSId = props.data?.DS?.id ||
      props.ds_id ||
      props.src ||
      DSFormats?.DS?.ds_id;

    if (value) {

      const { data:entriesData, error:entriesError } = (await postJSON(
        '/api/data_entries/find-some',
        {
          ids: value,
          lookupOrGrid: 'Lookup',
          DS: localDSId,
          DGs: lookupFieldsToFetch,
          includeDSInfo: true
        }
      ));

      if (entriesError) {
        console.error(entriesError);
        toast.error(gt(`Could not retrieve the values for the "${label || name}" picker`));
        setLoading(false);
      }

      const entriesToUse = [];
      entriesData?.forEach(entry => {
        const {
          id,
          ...DGs
        } = entry;
        const value = {};
        value.id = id;

        for (let dgNameAndField in DGs) {
          const [groupId, fieldName] = dgNameAndField.split('@');
          value[groupId] = value[groupId] || {};
          value[groupId][fieldName] = DGs[dgNameAndField];
        }

        entriesToUse.push(value);
      });

      setLocalValue(entriesToUse);
    }

    setDSId(localDSId);
    setLocalFormat(formatsFromDGs(DSFormats?.DGs || {})); // triggers the effect above
    setLoading(false);
  }

  function applyOptions (value) {

    setLocalOptions(
      (
        Array.isArray(value)
          ? value
          : Object.values(value || {})
      ).map(val => {
        // const format = value.format || localFormat;
        const {
          id,
          ...DGs
        } = val;

        const textParts = [];

        Object.keys(DGs?.groups_values || DGs || {}).forEach(dgId => {
          const DIs = DGs?.groups_values?.[dgId] || DGs[dgId];
          Object.entries(DIs)
            .forEach(([name, value], /*i*/) => {
              if (!localFormat?.[dgId]?.[name]) {
                return;
              }
              const inputFormat = localFormat
                ?.[dgId]?.[name] ||
                { type: 'text' };

              let El = null;

              switch (inputFormat.type) {
              case 'color':
                El = (
                  <span
                    key={val.id}
                    className={css['selected-option']}
                  >
                    <div
                      className={css['color-sample']}
                      style={{background: value}}
                      title={value}
                    />
                  </span>
                );
                break;
              case 'editor':
              case 'wysiwyg':
              case 'long':
              case 'textarea':
                El = (
                  <span
                    key={val.id}
                    className={css['selected-option']}
                  >
                    {cropString((value || '').toString(), 3)}
                  </span>
                );
                break;
              default:
                El = (
                  <span
                    key={val.id}
                    className={css['selected-option']}
                  >
                    {
                      isNullish(value)
                        ? ''
                        : value.toString()
                    }
                  </span>
                );
                break;
              }

              textParts.push({
                format: inputFormat,
                el: El
              });
            });
        });

        let text = textParts.sort(DISorter).map(item => {
          return item.el;
        });

        if (!text.length) {
          text = '???';
        }

        return {
          key: val.id,
          value: val.id,
          text
        };
      }));
  }

  return <div
    className={`${css["atom__dynamic-picker-container"]} ${className} field`}
    {...other}
  >
    <label>{label}{required ? '*' : ''}</label>

    <input
      type='number'
      className={css['hiddenInput']}
      value={value?.length || ''}
      min={other?.multiple_min || 0}
      max={other?.multiple_max || undefined}
      readOnly={props.readOnly}
      required={required}
    />

    <Dropdown
      fluid
      multiple={multiple}
      selection
      required={required}
      name={name}
      onChange={(event, target) => {
        // TODO: aqui lookup should allow removing items when multiple
        // const ev = {...event};
        // const target = t || ev.target || {};
        // target.value = Object.keys(value || {});
        // target.name = name;
        // setLocalFormat(value.format || localFormat);
        // // applyOptions(value, value.format);
        // // target.scope = scope;
        // onChange && onChange(ev, target);
        if (multiple && value.length > target.value.length) {
          // removed an item
          const ev = createFakeEvent(target.name, target.value);
          setLocalValue(curLocalValue => {
            const itemsToStay = [];
            // !
            // !
            // !
            // AQUI ... curLocalValue é um objeto enquanto value é uma array
            // !
            // !
            // !
            // console.log(target.value, curLocalValue);
            // debugger;
            // curLocalValue && curLocalValue.forEach(value => {
            //   if (value && target.value.includes(value.id)) {
            //     itemsToStay.push(value);
            //   }
            // });

            // debugger;
            target.value.forEach((item) => {
              // itemsToStay.push(curLocalValue.find(val => val === item));
              itemsToStay[item] = curLocalValue[item];
            });
            // console.log(111222, itemsToStay);
            onChange && onChange(ev, ev.target);
            // return [...itemsToStay];
            return { ...itemsToStay };
          });
        }
      }}
      {...other}
      onClick={event => {
        if (other?.loading || loading) {
          return;
        }

        apis.window.spawn(
          'DSCrudModules',
          {
            context: 'picker',
            multiple,
            readOnly: props.readOnly,
            DS: { id: props.src || props.ds_id || DSId, name: props.srcName },
            title: props.label || props.name,
            // doneLabel: "OK",
            // cancelLabel: 'Cancel',
            multiple_max: props.multiple_max,
            multiple_min: props.multiple_min,
            selected: localValue,

            onDone: (value) => {
              const ev = {...event};
              const target = ev.target || {};

              if (multiple) {
                target.value = Object.keys(value || {});
              } else {
                target.value = Object.keys(value || {})?.[0] || null;
              }

              target.name = name;

              if (!localFormat && value.format) {
                setLocalFormat(formatsFromDGs(value.format));
              }

              setLocalValue(value);
              // applyOptions(value, value.format);
              // target.scope = scope;
              onChange && onChange(ev, target);
            },
            onCancel: (event, target) => {
              // debugger; console.log(event, target);
            },
          },
          {
            tied: true,
            windowOptions: {
              width: 520,
              height: 380,
            }
          }
        );
      }}
      value={
        multiple
          ? (arrayOrNull(value) || [])
          : value
      }
      // options={multiple ? localOptions || [] : undefined}
      options={localOptions || []}
      disabled={other?.disabled}
      readOnly={other.readOnly || other?.loading || loading}
      // value={['aa']}
      // icon={<Icon name='searchengin' inverted circular />}
      icon={'search'}
      loading={other?.loading || loading}
    />
    {children}
  </div>;
}

export default LookupPicker;
